import { XStack, YStack } from 'tamagui';

import { type ColorTokenKey } from '../../themes/SmoothieColorTokens';
import {
    FruitfulCustomIcon,
    type FruitfulCustomIconSize,
} from '../icons/FruitfulCustomIcon';
import { Shadows } from '../Shadows';
import { BodyMediumRegular, BodySmallRegular } from '../text/Typography';

interface AccountAllocationCardProps {
    label: string;
    labelColor?: ColorTokenKey;
    accountName: string;
    accountSubtitle: string;
    amountText: string;
    icon?: string | null;
    iconColor?: string | null;
    iconSize?: FruitfulCustomIconSize;
}

export const AccountAllocationCard = ({
    label,
    labelColor = '$waterDark',
    accountName,
    accountSubtitle,
    amountText,
    icon = 'fruitful',
    iconColor = 'blue',
    iconSize = 'sm',
}: AccountAllocationCardProps) => {
    return (
        <YStack
            width="100%"
            backgroundColor="rgba(255, 255, 255, 0.5)"
            borderRadius={16}
            borderWidth={1}
            borderColor="$white"
            {...Shadows.SMALL}
        >
            <XStack
                paddingHorizontal={16}
                paddingVertical={8}
                borderBottomWidth={1}
                borderBottomColor="$white"
                backgroundColor="rgba(255, 255, 255, 0.50)"
                borderTopLeftRadius={16}
                borderTopRightRadius={16}
            >
                <BodySmallRegular color={labelColor} fontWeight="600">
                    {label}
                </BodySmallRegular>
            </XStack>
            <XStack alignItems="center" gap={12} padding={16}>
                <FruitfulCustomIcon
                    icon={icon}
                    color={iconColor}
                    size={iconSize}
                    showShadow={false}
                />
                <YStack flex={1} gap={4}>
                    <BodyMediumRegular>{accountName}</BodyMediumRegular>
                    <BodySmallRegular color="$gray1000">
                        {accountSubtitle}
                    </BodySmallRegular>
                </YStack>
                <BodyMediumRegular>{amountText}</BodyMediumRegular>
            </XStack>
        </YStack>
    );
};
